import { InjectionToken } from '@angular/core';

import { Platform } from '../../../platform-call';

export interface CaMeetBackRef {
    startCall: (platform: Platform) => void;
}

export const CMPS_MEET_BACK_REF = new InjectionToken<CaMeetBackRef>(
    'CMPS_MEET_BACK_REF',
);

export * from './ca-meet.service';
